// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"770f1d55","372":"033417c2","407":"f42db045","464":"272bca5f"}[chunkId] + ".chunk.css";
};